import { Button, Divider, Input, Spin, TableColumnsType } from 'antd'
import React, { FC, useState } from 'react'

import { DistrictFilter } from './dto/gateway.dto'
import { useData } from './hooks/useData'
import { useDistricts } from './hooks/useDistricts'
import * as xlsx from 'xlsx'
import Table from '../../component/table'

const GatewayList: FC = (props) => {
    const [inputValue, setInputValue] = useState('')
    const [search, setSearch] = useState('')

    const { data, loading: dataLoading } = useData(search)
    const { districts, loading: districtsLoading } = useDistricts()

    const columns = (districtFilter: DistrictFilter[]): TableColumnsType => {
        return [
            {
                title: 'Gateway ID',
                dataIndex: 'gatewayId',
                sorter: (a: any, b: any) => (a.title > b.title ? -1 : 1),
            },
            {
                title: 'Router ID',
                dataIndex: 'routerId',
            },
            {
                title: 'District',
                dataIndex: 'district',
                filters: districtFilter,
                filterMultiple: true,
                onFilter: (value: string | number | boolean, record: any) => record.district.indexOf(value) === 0,
            },
        ]
    }

    return (
        <Spin spinning={dataLoading || districtsLoading}>
            <div>
                <table cellPadding={5} style={{ width: '400px' }}>
                    <tbody>
                        <tr>
                            <td align="left">Gateway ID Contains</td>
                            <td>
                                <Input
                                    style={{ maxWidth: 300 }}
                                    value={inputValue}
                                    onChange={(e) => setInputValue(e.target.value)}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <Button type="primary" style={{ width: '100%' }} onClick={(e) => setSearch(inputValue)}>
                                    Apply
                                </Button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div style={{ marginTop: '20px' }}>
                    <Divider />
                    <Button
                        type="primary"
                        onClick={() => {
                            const wb = xlsx.utils.book_new()
                            data.forEach((row: any) => {
                                delete row._id
                                delete row.__v
                            })
                            const sheet = xlsx.utils.json_to_sheet(data)
                            xlsx.utils.book_append_sheet(wb, sheet)
                            xlsx.writeFile(wb, 'devices.xlsx')
                        }}
                    >
                        Download
                    </Button>
                    <Divider />
                    <Table columns={columns(districts)} data={data} />
                </div>
            </div>
        </Spin>
    )
}

export default GatewayList
